'use client';

import { Tab, Tabs } from '@mui/material';
import { COLORS } from '@/constants';
import styled from 'styled-components';

export const WlasTabBar = styled(Tabs)`
  && {
    min-height: 42px;
    border-bottom: 2px solid ${COLORS['neutral/200']};

    .MuiTab-root {
      text-transform: none;
      font-size: 14px;
      font-weight: 500;
      min-height: 42px;
      padding: 0 4px;
      margin-right: 24px;
      color: ${COLORS['neutral/500']};
      border-bottom: 2px solid transparent;
      margin-bottom: -2px;
      transition: color 0.15s ease;

      &.Mui-disabled {
        color: ${COLORS['neutral/300']};
        cursor: not-allowed;
        pointer-events: auto;
      }
    }

    .Mui-selected {
      color: ${COLORS['primary/700']} !important;
      border-bottom: 2px solid ${COLORS['primary/700']};
    }

    .MuiTabs-indicator {
      display: none;
    }
  }
`;

export const WlasTab = styled(Tab)``;
